import React from 'react'
import '../styles/css/userpage.css'

const UserPage = () => {
  return (
    <div>
      <div className="userpage">
        <div className="container userpage_wrapper">
          <div className="userpage_overlay">
            <div className="userpage_left">
              <h1>Invest with Confidence</h1>
              <h2>powered by data driven insights</h2>
            </div>
            <div className="userpage_right"></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserPage
